module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header",
    staticStyle: {
      "direction": "ltr !important"
    }
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": _vm.shopUrl
    }
  }, [_c('h2', {
    staticClass: "logo__heading"
  }, [_vm._v("Braster")]), _vm._v(" "), _c('img', {
    staticClass: "logo__image",
    attrs: {
      "src": require("../../assets/images/braster-logo.png"),
      "alt": "Braster"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header__container"
  }, [_c('nav', {
    staticClass: "nav",
    class: {
      show: _vm.showMobileMenu
    }
  }, [_c('ul', {
    staticClass: "nav__row"
  }, [_c('li', {
    staticClass: "login-buy nav__list"
  }, [(_vm.userShopUrl) ? [_c('a', {
    staticClass: "nav__link login-buy",
    staticStyle: {
      "color": "#cf004a",
      "line-height": "40px",
      "height": "40px"
    },
    attrs: {
      "href": _vm.userShopUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('BUY_ONLINE')))])] : [_c('span', {
    staticClass: "nav__link login-buy",
    staticStyle: {
      "color": "#cf004a",
      "line-height": "40px",
      "height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$t('BUY_ONLINE')))])]], 2), _vm._v(" "), (!_vm.isUserLogged) ? _c('li', {
    staticClass: "login-buy nav__list"
  }, [_c('button', {
    staticClass: "nav__link login-buy",
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('LOGIN')) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.isUserLogged) ? _c('li', {
    staticClass: "login-buy nav__list"
  }, [_c('button', {
    staticClass: "nav__link login-buy",
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('LOGOUT')) + "\n                        ")])]) : _vm._e(), _vm._v(" "), [_c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_FIRMA_START')
    }
  }, [_vm._v(_vm._s(_vm.$t('ABOUT_COMPANY')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_TECHNOLOGY')
    }
  }, [_vm._v(_vm._s(_vm.$t('TECHNOLOGY')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_BRASTER®PRO')
    }
  }, [_vm._v(_vm._s(_vm.$t('BRASTER®PRO')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_EXAMINATION')
    }
  }, [_vm._v(_vm._s(_vm.$t('EXAMINATION')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_PROFILAKTYKA')
    }
  }, [_vm._v(_vm._s(_vm.$t('PREVENTION')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_NEWS')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('NEWS')) + "\n                            ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.$t('LINK_RELACJE_INWESTORSKIE')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('RELACJE_INWESTORSKIE')) + "\n                            ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__list"
  }, [_c('a', {
    staticClass: "nav__link",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_CONTACT')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('CONTACT')) + "\n                            ")])])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [(!_vm.isUserLogged) ? _c('button', {
    staticClass: "-button-light-grey -small-button buttons-container__button",
    staticStyle: {
      "line-height": "40px",
      "height": "40px",
      "font-size": "16px"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('LOGIN')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isUserLogged) ? _c('button', {
    staticClass: "-button-light-grey -small-button buttons-container__button",
    staticStyle: {
      "line-height": "40px",
      "height": "40px",
      "font-size": "16px"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('LOGOUT')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "choose-language"
  }, [_c('div', {
    staticClass: "dropdown",
    class: {
      open: _vm.isDropdownOpen
    }
  }, [_c('button', {
    staticClass: "-button-light-grey dropdown-toggle app-btn--small app-btn-default",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.isDropdownOpen = !_vm.isDropdownOpen
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('LANG')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('PAGE_LANGUAGE')))]), _vm._v(" "), _c('ul', {
    staticClass: "switch-lng__list"
  }, _vm._l((_vm.interfaceLanguages), function(lang) {
    return _c('li', {
      staticClass: "switch-lng__list__item",
      on: {
        "click": function($event) {
          return _vm.changeLanguage(lang)
        }
      }
    }, [_c('img', {
      staticClass: "switch-lng__flag",
      attrs: {
        "src": ("/src/assets/images/flags/" + lang + ".png")
      }
    }), _vm._v("\n                                    " + _vm._s(_vm.$t('NAME_NATIVE', lang)) + "\n                                ")])
  }), 0)])])])]), _vm._v(" "), _c('button', {
    staticClass: "hamburger",
    on: {
      "click": function($event) {
        _vm.showMobileMenu = !_vm.showMobileMenu
      }
    }
  }, [_c('span', {
    staticClass: "hamburger__lines"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ca3b0ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/the-header.vue
// module id = 1196
// module chunks = 0